import Vue from 'vue';
import VueRouter from 'vue-router';

import Guard from '@/apps/apply/services/me';
import Apply from '@/apps/apply/001/components/Apply';
import { getApplyBaseUrl } from '@/utils/helpers';

Vue.use(VueRouter);

const routes = [
    {
        path: '/:uuid',
        name: 'apply001',
        component: Apply,
        beforeEnter: Guard.getMe,
    },
];

const router = new VueRouter({
    mode: 'history',
    base: getApplyBaseUrl(),
    routes,
});

Vue.use(router);

export default router;
